<template>
  <b-form @submit="onSubmit" ref="form">
    <b-row>
      <b-col v-for="field in fieldsExtra" :key="field.key" :cols="field.col">
        <b-form-group :id="'input-add-group' + field.key">
          <div class="h-separator">
            <label :for="'input-add-' + field.key" class="title">{{ field.label }}{{ field.required ? " *" : ""
            }}</label>
            <span></span>
          </div>
          <template v-if="field.key === 'cep' || field.key === 'zip'">
            <b-form-input v-if="['text', 'email', 'tel', 'number'].includes(field.type)" :id="'input-add-' + field.key"
              v-model="form[field.key]" :type="field.type" v-maska="getMask(field.key)" :placeholder="field.label"
              :required="field.required" @blur="searchCep"></b-form-input>
          </template>
          <template v-else>
            <b-form-input v-if="field.key === 'endereco'" :id="'input-add-' + field.key" :value="form.endereco"
              @input="form.endereco = $event" type="text" :placeholder="field.label"
              :required="field.required"></b-form-input>
            <b-form-input v-else-if="['text', 'email', 'tel', 'number'].includes(field.type)"
              :id="'input-add-' + field.key" v-model="form[field.key]" :type="field.type" v-maska="getMask(field.key)"
              :placeholder="field.label" :required="field.required"></b-form-input>

            <b-form-select v-if="field.type === 'select'" :id="'input-add-' + field.key" :placeholder="field.label"
              v-model="form[field.key]" :options="field.options" :required="field.required">
              <template #first>
                <b-form-select-option :value="undefined" disabled>Por favor, selecione uma opção</b-form-select-option>
              </template>
            </b-form-select>
          </template>
        </b-form-group>
      </b-col>
    </b-row>

    <b-button type="submit" variant="primary">Salvar</b-button>
  </b-form>
</template>

<script>
import api from "@/services";
import { toast, errorFormater, userToExtraFields } from "@/utils";
import validateDoc from "@/validate";

export default {
  props: {
    group: {
      type: String,
      required: true,
    },
    module: {
      type: String,
      required: true,
    },
    modal: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        // Pré-declarar todos os campos para garantir a reatividade no Vue 2
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        uf: '',
        cep: '',
        zip: '',
        pais: '',
        email: '',
        telephone: '',
        name: '',
        cpf: '',
      },
      options_extra: [],
    };
  },
  created() {
    if (this.module === "senders") {
      const u = userToExtraFields(this.$store.state.user)
      if (u) {
        // Popula os campos pré-declarados
        Object.keys(this.form).forEach(key => {
          if (u[key] !== undefined) {
            this.form[key] = u[key]?.trim() || '';
          }
        });
      }
      if (this.form.complemento === '&') {
        this.form.complemento = ''
      }
    }
  },
  computed: {
    fieldsExtra() {
      const extraFields = this.$store.state.extrafield.groups[this.group]
        ? this.$store.state.extrafield.groups[this.group].map((e) => {
            const field = {
              key: e.key,
              label: e.description,
              type: e.children.length ? "select" : "text",
              options: e.children.map((v) => ({
                text: v.description,
                value: v.description,
              })),
              col: e.col,
              required: !!e.required,
            };

            if (this.module === 'senders' && field.key === 'cep') {
              field.label = 'ZIP';
            } else if (
              (this.module === 'senders' || this.module === 'receivers') &&
              field.key === 'zip'
            ) {
              field.label = 'Caixa de Correio';
            }
            return field;
          })
        : [];

      return [
        ...this.fields.map((f) => ({ ...f, required: !!1 })),
        ...extraFields,
      ];
    },
  },
  methods: {
    getMask(key) {
      switch (key) {
        case 'cep':
        case 'zip':
          return this.module === 'senders' ? '########' : '#####-###';
        case 'cpf':
          return ['###.###.###-##', '##.###.###/####-##'];
        case 'telephone':
          return [
            '+## (##) #####-####',
            '+## (###) ###-####',
            '+# (###) ###-####',
          ];
        default:
          return '';
      }
    },
    searchCep(e) {
      const value = e.target.value;
      if (value && value.replaceAll("-", "").length >= 8) { // Apenas para CEPs brasileiros
        api.get("endereco/" + value.replaceAll("-", "")).then(response => {
          const results = response.data?.results;
          if (response.status === 200 && results && results.length > 0 && results[0].raw) {
            const data = results[0].raw;

            this.form.endereco = data.logradouro;
            this.form.complemento = data.bairro;
            this.form.cidade = data.localidade;
            this.form.uf = data.uf;
            this.form.pais = 'Brasil';
          } else {
            if (this.module !== "senders") {
              this.form.endereco = '';
            }
            this.form.cidade = '';
            this.form.uf = '';
            this.form.pais = '';
            toast(
              this,
              "info",
              "Endereço",
              "Nenhum endereço foi encontrado com esse CEP."
            );
          }
        }).catch(error => {
          console.error("ERRO NA CHAMADA DA API DE CEP:", error);
          toast(
            this,
            "danger",
            "Erro ao buscar CEP",
            "Houve um problema ao consultar o CEP. Verifique o console para mais detalhes."
          );
        });
      }
    },
    updatePassword(e) {
      this.form.password = e;
      this.form.password_confirmation = e;
    },
    onSubmit(event) {
      event.preventDefault();
      // console.log(this.group);

      if (this.group !== "sender") {
        if (!validateDoc(this.form?.cpf)) {
          toast(this, "info", "CPF inválido", "o CPF ou CNPJ não é válido");
          return;
        }
      }

      api.post("auth/create", { ...this.form, group_key: this.group }).then(
        (response) => {
          if (response.status >= 200 && response.status < 300) {
            this.$store.dispatch(this.module + "/add", response.data.user);

            // Hide the modal manually
            this.$nextTick(() => {
              this.$bvModal.hide(this.modal);
            });

            this.$emit("finish");

            toast(
              this,
              "success",
              "Usuário registrado",
              "Usuário foi registrado com sucesso"
            );
          }
        },
        (error) => {
          toast(this, "danger", "Usuário não registrado", errorFormater(error));
          return Promise.reject(error);
        }
      );
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '../../style/main/colors.styl';

.h-separator {
  display: flex;

  .title {
    padding: 0px 10px;
    font-size: 14px;
    color: light;
    font-weight: bold;
    border-radius: 1rem;
    background: primary;
  }

  span {
    align-self: center;
  }

  span:last-child {
    border: 1px dashed primary;
    height: 1px;
  }

  span:last-child {
    flex-grow: 1;
  }
}

.btn {
  justify-content: space-between;
  margin-left: 10px;
  float: right;
}
</style>
